import React, { useEffect } from "react";

import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		backgroundColor: theme.palette.background.paper,
		flex: "none",
		borderBottom: `1px solid ${theme.palette.divider}`,
		height: "70px",
		alignItems: "center",
		padding: "0 8px",
		boxShadow: theme.mode === 'light' ? "0 1px 3px rgba(0,0,0,0.05)" : "0 1px 3px rgba(0,0,0,0.3)",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: 'max-content'
		},
	},
	backButton: {
		marginRight: theme.spacing(1),
		minWidth: "40px",
		width: "40px",
		height: "40px",
		borderRadius: "50%",
	}
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
					elevation={0}
				>
					<IconButton 
						onClick={handleBack}
						className={classes.backButton}
					>
						<ArrowBackIos fontSize="small" />
					</IconButton>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
